import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PROVIDER_PORTAL_MAIN_COLUMN_CLASS } from "./util/providerPortalMainColumn";
import SignatureReceived from "./Signatures/SignatureReceived";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { gql } from "./__generated__/gql";
import { useDocumentTitle } from "./util/documentTitle";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";
import { useQueryParams } from "./util/routerUtil";

type RouteParams = {
  orderNumber: string;
};

export const SIGN_ORDER = gql(`
  mutation SignOrder(
    $orderNumber: String!,
    $token: String!,
    $email: String!
    $reviewAll: Boolean
  ) {
    signOrder(
      orderNumber: $orderNumber,
      token: $token,
      email: $email,
      reviewAll: $reviewAll
    )
  }
`);

/**
 * React component to handle order update requests that come
 * from the "Signature Requested" email.
 */
const OrderSigned = () => {
  const [signOrder, { loading, data }] = useMutation(SIGN_ORDER, {
    fetchPolicy: "no-cache",
  });
  const success = !!data?.signOrder;

  const { orderNumber } = useParams<RouteParams>();
  useDocumentTitle(orderNumber ?? "");

  const queryParams = useQueryParams();
  const email = queryParams.get("email") ?? "";
  const token = queryParams.get("access_token") ?? "";

  useEffect(() => {
    signOrder({
      variables: {
        orderNumber: orderNumber ?? "",
        token: token,
        email: email,
      },
    });
  }, []);

  if (loading) {
    return (
      <div
        className={`${PROVIDER_PORTAL_MAIN_COLUMN_CLASS} tw-my-[25px] tw-flex tw-justify-center`}
      >
        <FontAwesomeIcon className="fa-pulse" icon={faSpinner} size="3x" />
      </div>
    );
  } else if (success) {
    return (
      <div className={PROVIDER_PORTAL_MAIN_COLUMN_CLASS}>
        <SignatureReceived />
      </div>
    );
  } else {
    return (
      <div
        className={`${PROVIDER_PORTAL_MAIN_COLUMN_CLASS} pol-wrapper tw-mb-[50px] tw-mt-[120px] tw-text-center`}
      >
        <h3>An Error Occurred</h3>
        <div>
          <p>
            Your signature has not been recorded, due to an authentication
            issue.
            <br /> Please contact{" "}
            <a href="mailto:support@versemedical.com">
              support@versemedical.com
            </a>{" "}
            and we'll look into this right away.
          </p>
        </div>
      </div>
    );
  }
};

export default OrderSigned;
